import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Width")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Height")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Left")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Top")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Δ Width")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Δ Height")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Angle")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Scale")

import { NkButton, NkDivider, NkGroup, NkInlineModal, NkStack, NkText } from '@/core/components';
import {
  computed, inject,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  shallowRef,
  watch,
} from 'vue';
import { fabric } from 'fabric';

import InspectionImageDeleteForm
  from '@/entities/inspection-image/components/forms/InspectionImageDeleteForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageAssemblerObjectControls',
  props: {
  getCanvas: {
    type: Function,
    required: true,
  },
},
  emits: ['deleted'],
  setup(__props, { emit }) {

const props = __props

const hasInputFocus = ref(false);




const imageAssembler: any = inject('imageAssembler');
const activeObject = shallowRef<fabric.Object | null>(null);
const activeObjectForm = reactive({
  width: 0,
  height: 0,
  angle: 0,
  left: 0,
  top: 0,
  scale: 1,
  baseWidth: 0,
  baseHeight: 0,
});
const updateForm = () => {
  if (hasInputFocus.value) {
    return;
  }
  activeObjectForm.width = Math.round((activeObject.value?.width ?? 0) * (activeObject.value?.scaleX ?? 0));
  activeObjectForm.height = Math.round((activeObject.value?.height ?? 0) * (activeObject.value?.scaleY ?? 0));
  activeObjectForm.angle = Math.round((activeObject.value?.angle ?? 0) * 10) / 10;
  activeObjectForm.left = Math.round(activeObject.value?.left ?? 0);
  activeObjectForm.top = Math.round(activeObject.value?.top ?? 0);
  activeObjectForm.baseWidth = Math.round(activeObject.value?.width ?? 0);
  activeObjectForm.baseHeight = Math.round(activeObject.value?.height ?? 0);
  activeObjectForm.scale = Math.round((activeObject.value?.scaleX ?? 1) * 100) / 100;
};

const centerView = () => {
  const canvas = props.getCanvas();
  if (canvas && activeObject.value) {
    const zoom = canvas.getZoom();
    canvas.setZoom(1);  // reset zoom so pan actions work as expected
    const vpw = (canvas.width ?? 0) / zoom;
    const vph = (canvas.height ?? 0) / zoom;
    const x = ((activeObject.value.left ?? 0) - vpw / 2) + (activeObject.value.width ?? 0) / 2;  // x is the location where the top left of the viewport should be
    const y = ((activeObject.value.top ?? 0) - vph / 2) + (activeObject.value.height ?? 0) / 2;  // y idem
    canvas.absolutePan({
      x,
      y,
    });
    canvas.setZoom(zoom);
    canvas.fire('pan');
  }
};
watch(activeObject, updateForm);

const updateWidth = (value: number) => {
  activeObjectForm.width = value;
  const scale = activeObjectForm.width / (activeObject.value?.width ?? 1);
  activeObjectForm.height = Math.round((activeObject.value?.height ?? 1) * scale);
};

const updateHeight = (value: number) => {
  activeObjectForm.height = value;
  const scale = activeObjectForm.height / (activeObject.value?.height ?? 1);
  activeObjectForm.width = Math.round((activeObject.value?.width ?? 1) * scale);
};

const getIndex = computed(() => {
  if (activeObject.value) {
    const index = imageAssembler.canvasImages.value?.findIndex((o: any) => activeObject.value?.id === o.id);
    return index + 1;
  }

  return null;
})

const resetScale = () => {
  updateWidth(activeObjectForm.baseWidth);
  updateHeight(activeObjectForm.baseHeight);
};

watch(() => activeObjectForm, () => {
  const canvas = props.getCanvas();
  if (canvas && activeObject.value) {
    const scale = activeObjectForm.width / (activeObject.value?.width ?? 1);
    activeObject.value.set({
      scaleX: scale,
      scaleY: scale,
      angle: activeObjectForm.angle,
      left: activeObjectForm.left,
      top: activeObjectForm.top,
    });
    activeObject.value.fire('modified');
    canvas.fire('object:modified', { target: activeObject.value });
    canvas.renderAll();
  }
}, { deep: true });

onMounted(() => {
  const canvas = props.getCanvas();
  if (canvas) {
    activeObject.value = canvas.getActiveObject();
    activeObject.value?.on('modified', updateForm);
    activeObject.value?.on('scaling', updateForm);
    activeObject.value?.on('rotating', updateForm);
    activeObject.value?.on('transform', updateForm);
  }
});
onBeforeUnmount(() => {
  activeObject.value?.off('modified', updateForm);
  activeObject.value?.off('scaling', updateForm);
  activeObject.value?.off('rotating', updateForm);
  activeObject.value?.off('transform', updateForm);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkStack), null, {
    default: _withCtx(() => [
      _createVNode(_unref(NkGroup), { position: "apart" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkText), { type: "bold" }, {
            default: _withCtx(() => [
              _createTextVNode(" #" + _toDisplayString(_unref(getIndex)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(NkButton), {
            circle: "",
            icon: "NkVisibility",
            type: "white",
            onClick: _withModifiers(centerView, ["prevent"])
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_unref(NkGroup), { noWrap: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkStack), {
            spacing: 1,
            class: "!flex-1 shrink-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { type: "semibold" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(activeObjectForm.baseWidth), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(NkStack), {
            spacing: 1,
            class: "!flex-1 shrink-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { type: "semibold" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(activeObjectForm.baseHeight), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(NkDivider)),
      _createVNode(_unref(NkGroup), { noWrap: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkStack), {
            spacing: 1,
            class: "!flex-1 shrink-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { type: "semibold" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeObjectForm.left) = $event)),
                class: "border rounded px-2 w-full min-w-0",
                type: "number",
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (hasInputFocus.value = false)),
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (hasInputFocus.value = true))
              }, null, 544), [
                [_vModelText, activeObjectForm.left]
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NkStack), {
            spacing: 1,
            class: "!flex-1 shrink-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { type: "semibold" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeObjectForm.top) = $event)),
                class: "border rounded px-2 w-full min-w-0",
                type: "number",
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (hasInputFocus.value = false)),
                onFocus: _cache[5] || (_cache[5] = ($event: any) => (hasInputFocus.value = true))
              }, null, 544), [
                [_vModelText, activeObjectForm.top]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(NkGroup), { noWrap: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkStack), {
            spacing: 1,
            class: "!flex-1 shrink-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { type: "semibold" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeObjectForm.width) = $event)),
                class: "border rounded px-2 w-full min-w-0",
                type: "number",
                onBlur: _cache[7] || (_cache[7] = ($event: any) => (hasInputFocus.value = false)),
                onFocus: _cache[8] || (_cache[8] = ($event: any) => (hasInputFocus.value = true)),
                onInput: _cache[9] || (_cache[9] = (e) => updateWidth(Number(e.target.value)))
              }, null, 544), [
                [_vModelText, activeObjectForm.width]
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NkStack), {
            spacing: 1,
            class: "!flex-1 shrink-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { type: "semibold" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((activeObjectForm.height) = $event)),
                class: "border rounded px-2 w-full min-w-0",
                type: "number",
                onBlur: _cache[11] || (_cache[11] = ($event: any) => (hasInputFocus.value = false)),
                onFocus: _cache[12] || (_cache[12] = ($event: any) => (hasInputFocus.value = true)),
                onInput: _cache[13] || (_cache[13] = (e) => updateHeight(Number(e.target.value)))
              }, null, 544), [
                [_vModelText, activeObjectForm.height]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(NkGroup), { noWrap: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkStack), {
            spacing: 1,
            class: "!flex-1 shrink-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { type: "semibold" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((activeObjectForm.angle) = $event)),
                class: "border rounded px-2 w-full min-w-0",
                max: "360",
                min: "0",
                step: "0.1",
                type: "number",
                onBlur: _cache[15] || (_cache[15] = ($event: any) => (hasInputFocus.value = false)),
                onFocus: _cache[16] || (_cache[16] = ($event: any) => (hasInputFocus.value = true))
              }, null, 544), [
                [_vModelText, activeObjectForm.angle]
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NkStack), {
            spacing: 1,
            class: "!flex-1 shrink-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkText), { type: "semibold" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_unref(NkGroup), { position: "apart" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(activeObjectForm.scale), 1),
                  _createVNode(_unref(NkButton), {
                    size: "xs",
                    type: "white",
                    onClick: resetScale
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('actions.reset')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(NkDivider)),
      _createVNode(_unref(NkGroup), {
        noWrap: "",
        position: "apart"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkInlineModal), {
            title: _ctx.$t('inspection-group.action.delete_image'),
            class: "max-w-screen-md"
          }, {
            content: _withCtx(({close}) => [
              _createVNode(InspectionImageDeleteForm, {
                id: _unref(activeObject)?.id,
                onSubmitted: () => {
                          close();
                          emit('deleted');
                        }
              }, null, 8, ["id", "onSubmitted"])
            ]),
            default: _withCtx(() => [
              (_ctx.$store.getters['connection/isGranted'](['inspection_annotation']))
                ? (_openBlock(), _createBlock(_unref(NkButton), {
                    key: 0,
                    size: "sm",
                    type: "danger",
                    onClick: resetScale
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('actions.delete')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})